import React from 'react'
import {CardMedia} from '@mui/material'
import {isEmpty} from 'react-lf-tools'
import food from '../../../assets/food.jpg'

import './imageProduct.scss'

const ImageProduct = ({image}) => <div className={'image-product'}>
    <CardMedia
        image={(!isEmpty(image)) ? image : food}
        id={'image-product-bag'}
        className={'card-media-image-product'}/>
</div>

export default ImageProduct
